import React, { useEffect, useRef } from 'react';

export const useIsFirstRender = () => {
  const isMounted = useRef(true);

  useEffect(() => {
    isMounted.current = false;
  }, []);

  return isMounted.current;
};